import React, { useEffect, useState } from 'react'
import { Box, Button, Grid, IconButton, InputAdornment, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material'
import * as PXBColors from '@brightlayer-ui/colors';
import { Close, GetApp, Search, ArrowDropDown } from '@mui/icons-material';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { selectStyle } from '../assets/selectStyle';
import MaintenanceLogCard from './MaintenanceLogCard';
import { Spacer } from '@brightlayer-ui/react-components';
import { useDispatch, useSelector } from 'react-redux';
import { Thunks } from '../../actions';
import { Selectors } from '../../selectors';
import { ServiceStatus } from '../enum/ENUM';
import { MaintenanceHistoryDetails } from '../../types/maintenance';
import { vh_26 } from '../../constants/dimentions';
import MaintenanceLogCardFor30Days from './MaintenanceLogCardFor30Days';
import { useOrganizationList } from '../../data/DataProviders/OrganizationListProvider';
import { ItemList } from '../../types/logbook-type';
import { customerListV2Data } from '../../types/customer-detail';
import { DeviceList } from '../../types/device';
import { TechnicianData } from '../../types/technicians';
import { DropDownListComponent } from '../../components/DropDownList/DropDownListComponent';
import { BuildingList } from '../../types/building';

type Props = {
    onClick: Function;
    organizationId: string;
    customerId: string;
    selectedSystemId: string;
}

const MaintenanceHistory = (props: Props) => {
    const [searchQuery, setSearchQuery] = useState('');
    const [organizationType, setOrganizationType] = useState(props.organizationId || "")
    const [customerType, setCustomerType] = useState(props.customerId || "")
    const [ticketNumberType, setTicketNumberType] = useState("")
    const [technicianType, setTechnicianType] = useState("")
    const dispatch = useDispatch();
    const { t } = useLanguageLocale();
    const [organizationListData, setOrganizationListData] = React.useState<ItemList>([]);
    const useOrganizationDataList = useOrganizationList();
    const [firstCall, setFirstCall] = React.useState(true);
    const [focusedOrganization, setFocusedOrgnaization] = React.useState(organizationType ? true : false);
    const [focusedCustomer, setFocusedCustomer] = React.useState(customerType ? true : false);
    const [customerList, setCustomerList] = React.useState<ItemList>([]);
    const [systemId, setSystemId] = React.useState(props.selectedSystemId || "");
    const [focusedSystem, setFocusedSystem] = React.useState(false);
    const [focusedTechnician, setFocusedTechnician] = React.useState(false);
    const [focusedServiceType, setFocusedServiceType] = React.useState(false);
    const customer = useSelector(Selectors.Customer.customer);
    const asset = useSelector(Selectors.Asset.assets);
    const [systemList, setSystemList] = useState<ItemList>([]);
    const [technicianList, setTechnicianList] = useState<TechnicianData>([])
    const userManagement = useSelector(Selectors.Usermanagement.usermanagement);
    const dashboard = useSelector(Selectors.Dashboard.dashboard);
    const [buildings, setBuildings] = useState<ItemList>([]);
    const [filterBuilding, setFilteredBuilding] = React.useState("");
    const [buildingId, setBuildingId] = React.useState("");


    const onChangeSearchText = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
        setSearchQuery(e.target.value);
    };

    const resetSearch = (): void => {
        setSearchQuery('');
    };

    const handleOrganizationTypeChange = (event: SelectChangeEvent) => {
        setOrganizationType(event.target.value)
        setFocusedOrgnaization(event.target.value !== '');
        setCustomerType('');
        setSystemId('');
        setFocusedCustomer(false);
        setFocusedSystem(false);
    }

    const handleCustomerTypeChange = (event: SelectChangeEvent) => {
        setCustomerType(event.target.value)
        setFocusedCustomer(event.target.value !== '');
        setSystemId('');
        setFocusedSystem(false);
    }

    const systemOnChange = (event: SelectChangeEvent) => {
        setSystemId(event.target.value);
        setFocusedSystem(event.target.value !== '');
    };

    const handleTicketNumberTypeChange = (event: SelectChangeEvent) => {
        setTicketNumberType(event.target.value);
        setFocusedServiceType(event.target.value !== '');
    }

    const handleTechnicianType = (event: SelectChangeEvent) => {
        setTechnicianType(event.target.value)
        setFocusedTechnician(event.target.value !== '')
    }

    const handleDisplay = (value: {
        maintenance: MaintenanceHistoryDetails;
    }): void => {
        props.onClick({ maintenance: value.maintenance });
    };

    useEffect(() => {
        setOrganizationListData(useOrganizationDataList.organizationList);
    }, [useOrganizationDataList, useOrganizationDataList.organizationList]); //eslint-disable-line react-hooks/exhaustive-deps


    useEffect(() => {
        // dispatch(Thunks.UserManagement.getMaintenanceDetail(organizationType, "", technicianType, "", customerType, "", systemId, filterBuilding, currentPage.toString(), rowsPerPage.toString(), "", "", endDate.toISOString(), TICKET_STATUS.STATUS_COMPLETED));
        dispatch(Thunks.Asset.getDeviceList(organizationType, '', '', '', '', '', '', customerType));
        dispatch(Thunks.Customer.getCustomerListV2(organizationType));
        dispatch(Thunks.UserManagement.getTechniciansList("", ""));
        dispatch(Thunks.Dashboard.getBuildingList(organizationType, "", "", "", [], null, null, false, true));
        setFirstCall(false)
    }, [])  // eslint-disable-line react-hooks/exhaustive-deps


    useEffect(() => {
        if (!firstCall) {
            // dispatch(Thunks.UserManagement.getMaintenanceDetail(organizationType, "", technicianType, "", customerType, "", systemId, filterBuilding, currentPage.toString(), rowsPerPage.toString(), "", "", endDate.toISOString(), TICKET_STATUS.STATUS_COMPLETED, ticketNumberType === "" ? undefined : Number(ticketNumberType)));
            dispatch(Thunks.Asset.getDeviceList(organizationType, '', '', '', '', '', '', customerType));
            dispatch(Thunks.Customer.getCustomerListV2(organizationType));
            dispatch(Thunks.Dashboard.getBuildingList(organizationType, "", "", "", [], null, null, false, true));
            setBuildingId(organizationType)
        }
    }, [organizationType, customerType, systemId, technicianType, filterBuilding, ticketNumberType])  // eslint-disable-line react-hooks/exhaustive-deps

    const customerListData = (list: customerListV2Data): ItemList => {
        return list?.map((data, customer) => {
            return {
                id: data.id,
                name: data.companyName,
                number: data.customerNumber
            };
        });
    };

    useEffect(() => {
        if (!customer.customerListLoading && customer.customerListSuccess) {
            setCustomerList(customerListData(customer.customerList.customerDetailList));
        }
        else if (!customer.customerListLoading && customer.customerListFail) {
            setCustomerList([]);
        }
    }, [customer.customerListLoading, customer.customerListSuccess, customer.customerListFail]); // eslint-disable-line react-hooks/exhaustive-deps



    const systemListLogbook = (list: DeviceList): ItemList => {
        return list?.map((data, system) => {
            return {
                id: data.systemId,
                name: data.systemName,
            };
        });
    };

    useEffect(() => {
        if (!asset.deviceListLoading && asset.deviceListSuccess) {
            setSystemList(systemListLogbook(asset.deviceList.detail));
        } else if (!asset.deviceListLoading && asset.deviceListFail) {
            setSystemList([]);
        }
    }, [asset.deviceListLoading, asset.deviceListSuccess, asset.deviceListFail]); // eslint-disable-line react-hooks/exhaustive-deps


    const technicianListLogbook = (list: TechnicianData): TechnicianData => {
        return list.map((data) => {
            return (
                {
                    userName: data.userName,
                    id: data.id,
                }
            );
        })
    }

    useEffect(() => {
        if (!userManagement.technicianListLoading && userManagement.technicianListSuccess) {
            setTechnicianList(technicianListLogbook(userManagement.technicianList.detail))
        } else if (!userManagement.technicianListLoading && userManagement.technicianListFail) {
            setTechnicianList([])
        }
    }, [userManagement.technicianListLoading, userManagement.technicianListSuccess, userManagement.technicianListFail]); // eslint-disable-line react-hooks/exhaustive-deps

    const buildingListData = (list: BuildingList): ItemList => {
        return list?.map((data, building) => {
            return {
                id: data.buildingId,
                name: data.name,
            };
        });
    };

    useEffect(() => {
        if (!dashboard.buildingListLoading && dashboard.buildingListSuccess) {
            setBuildings(buildingListData(dashboard.buildingList.detail));
        } else if (!dashboard.buildingListLoading && dashboard.buildingListFail) {
            setBuildings([]);
            setBuildingId("");
        }
    }, [dashboard.buildingListLoading, dashboard.buildingListSuccess, dashboard.buildingListFail]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            <div data-testid="maintenance-history-container">
                <Box style={{
                    paddingLeft: '5%',
                    paddingTop: vh_26,
                    paddingRight: '5%',
                    backgroundSize: 'contain',
                    alignItems: 'center',
                }}>
                    <Grid container spacing={2}>
                        <Grid item xs={10}>
                            <Box>
                                <TextField
                                    inputProps={{ 'data-testid': 'searchText-field', maxLength: 100 }}
                                    value={searchQuery}
                                    style={{
                                        width: '95%',
                                        borderRadius: 5,
                                        backgroundColor: PXBColors.white[50],
                                        fontSize: 12,
                                        fontWeight: 400,
                                    }}
                                    placeholder={t('ORGANIZATION_MANAGE.SEARCH_BUILDINGS')}
                                    onChange={(e): void => onChangeSearchText(e)}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Search data-testid="search-icon" style={{ color: PXBColors.gray[500] }} />
                                            </InputAdornment>
                                        ),
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                {searchQuery !== '' && (
                                                    <IconButton onClick={resetSearch}>
                                                        <Close data-testid="close-search-icon" fontSize="small" />
                                                    </IconButton>
                                                )}
                                            </InputAdornment>
                                        ),
                                    }}
                                    variant="outlined"
                                />
                            </Box>
                        </Grid>
                        <Grid item xs={2} style={{ backgroundImage: "pink" }}>
                            <Box >
                                <Button variant="contained"
                                    sx={{ marginTop: '2%', paddingTop: '5%', paddingBottom: '5%' }}
                                    startIcon={<GetApp />} endIcon={<ArrowDropDown />}>
                                    {t('ASSETS_DETAILS.DOWNLOAD_AS')}
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>

                    {/* //for filter list */}
                    <div data-testid="maintenance-history-filter">
                        <div style={{ display: 'flex', }}>
                            <Select
                                disabled={!useOrganizationDataList.orgListLoaded}
                                id="project-list-dropdown-organization"
                                data-testid="maintenance-project-filter-organization"
                                style={{
                                    backgroundColor: focusedOrganization ? PXBColors.lightBlue[50] : PXBColors.white[50],
                                    marginRight: '1%',
                                    width: 'auto',
                                    height: 32,
                                    borderBlock: 0,
                                    outline: 'none',
                                    borderRadius: 32,
                                    overflow: 'hidden',
                                    fontSize: 14,
                                    color: focusedOrganization ? PXBColors.blue[500] : PXBColors.black[500],
                                    fontStyle: 'normal',
                                    fontWeight: 400,
                                    marginTop: 28,
                                }}
                                value={organizationType}
                                onChange={handleOrganizationTypeChange}
                                displayEmpty
                            >
                                <MenuItem value=""
                                    style={selectStyle.dropdown}> {t('MAINTENANCE_DETAILS.ORGANIZATION_ALL')}</MenuItem>
                                {organizationListData?.map((data, val) => {
                                    return (
                                        <MenuItem id="system-list" key={data.id} value={data.id} style={selectStyle.dropdown}>
                                            {data.name}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                            <Select
                                disabled={customer.customerListLoading}
                                displayEmpty
                                id="project-list-dropdown-customer"
                                data-testid="maintenance-project-filter-customer"
                                style={{
                                    backgroundColor: focusedCustomer ? PXBColors.lightBlue[50] : PXBColors.white[50],
                                    marginRight: '1%',
                                    width: 'auto',
                                    height: 32,
                                    borderBlock: 0,
                                    outline: 'none',
                                    borderRadius: 32,
                                    overflow: 'hidden',
                                    fontSize: 14,
                                    color: focusedCustomer ? PXBColors.blue[500] : PXBColors.black[500],
                                    fontStyle: 'normal',
                                    fontWeight: 400,
                                    marginTop: 28,
                                }}
                                value={customerType}
                                onChange={handleCustomerTypeChange}
                            >
                                <MenuItem value="" style={selectStyle.dropdown}> {t('MAINTENANCE_DETAILS.CUSTOMER_All')}</MenuItem>
                                {customerList?.map((data, val) => {
                                    return (
                                        <MenuItem id="system-list" key={data.id} value={data.id} style={selectStyle.dropdown}>
                                            {data.name}
                                        </MenuItem>
                                    );
                                })}
                            </Select>

                            <Select
                                disabled={asset.deviceListLoading}
                                id="project-list-dropdown-system"
                                data-testid="maintenance-project-filter-system"
                                displayEmpty
                                style={{
                                    backgroundColor: focusedSystem ? PXBColors.lightBlue[50] : PXBColors.white[50],
                                    marginRight: '1%',
                                    width: 'auto',
                                    height: 32,
                                    borderBlock: 0,
                                    outline: 'none',
                                    borderRadius: 32,
                                    overflow: 'hidden',
                                    fontSize: 14,
                                    color: focusedSystem ? PXBColors.blue[500] : PXBColors.black[500],
                                    fontStyle: 'normal',
                                    fontWeight: 400,
                                    marginTop: 28,
                                }}
                                value={systemId}
                                onChange={systemOnChange}
                            >
                                <MenuItem value="" style={selectStyle.dropdown}> {t('SEARCH.ALL_SYSTEMS')}</MenuItem>
                                {systemList?.map((data, val) => {
                                    return (
                                        <MenuItem id="system-list" key={data.id} value={data.id}
                                            style={selectStyle.dropdown}>
                                            {data.name}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </div>

                        <div style={{ display: 'flex' }}>
                            <Select
                                id="project-list-dropdown-ticketNo"
                                data-testid="maintenance-project-filter-ticketNo"
                                displayEmpty
                                style={{
                                    backgroundColor: focusedServiceType ? PXBColors.lightBlue[50] : PXBColors.white[50],
                                    marginRight: '1%',
                                    width: 'auto',
                                    height: 32,
                                    borderBlock: 0,
                                    outline: 'none',
                                    borderRadius: 32,
                                    overflow: 'hidden',
                                    fontSize: 14,
                                    color: focusedServiceType ? PXBColors.blue[500] : PXBColors.black[500],
                                    fontStyle: 'normal',
                                    fontWeight: 400,
                                    marginTop: 28,
                                }}
                                value={ticketNumberType}
                                onChange={handleTicketNumberTypeChange}
                            >
                                <MenuItem value="" style={selectStyle.dropdown}> {t('SEARCH.ALL_SERVICE_TYPES')}</MenuItem>
                                {ServiceStatus.map((data) => {
                                    return (
                                        <MenuItem id="system-list" key={data.id} value={data.id}
                                            style={selectStyle.dropdown}>
                                            {t(data.name)}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                            <DropDownListComponent disabled={dashboard.buildingListLoading} data-testid="maintenance-buildings-project-filter" list={buildings} value={t('SEARCH.ALL_BUILDINGS')} handleSelection={setFilteredBuilding} selected={buildingId} defaultSelection={""}></DropDownListComponent>
                            <Select
                                disabled={userManagement.technicianListLoading}
                                id="project-list-dropdown-technician"
                                data-testid="maintenance-project-filter-technician"
                                displayEmpty
                                style={{
                                    backgroundColor: focusedTechnician ? PXBColors.lightBlue[50] : PXBColors.white[50],
                                    marginRight: '1%',
                                    width: 'auto',
                                    height: 32,
                                    borderBlock: 0,
                                    outline: 'none',
                                    borderRadius: 32,
                                    overflow: 'hidden',
                                    fontSize: 14,
                                    color: focusedTechnician ? PXBColors.blue[500] : PXBColors.black[500],
                                    fontStyle: 'normal',
                                    fontWeight: 400,
                                    marginTop: 28,
                                }}
                                value={technicianType}
                                onChange={handleTechnicianType}
                            >
                                <MenuItem value="" style={selectStyle.dropdown}> {t('MAINTENANCE_DETAILS.TECHNICIAN_ALL')}</MenuItem>
                                {technicianList.map((data) => {
                                    return (
                                        <MenuItem id="system-list" key={data.id} value={data.id}
                                            style={selectStyle.dropdown}>
                                            {data.userName}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </div>
                    </div>

                    <Spacer style={{ height: 16 }} placeholder={undefined} />

                    <MaintenanceLogCard
                        title={t('MAINTENANCE_DETAILS.COMPLETED_7_DAYS')}
                        displayClick={handleDisplay}
                        organizationType={organizationType}
                        customerType={customerType}
                        systemId={systemId}
                        filterBuilding={filterBuilding}
                        technicianType={technicianType}
                        serviceType={ticketNumberType}
                    />
                    <Spacer style={{ height: 16 }} placeholder={undefined} />

                    <MaintenanceLogCardFor30Days
                        title={t('MAINTENANCE_DETAILS.COMPLETED_30_DAYS')}
                        displayClick={handleDisplay}
                        organizationType={organizationType}
                        customerType={customerType}
                        systemId={systemId}
                        filterBuilding={filterBuilding}
                        technicianType={technicianType}
                        serviceType={ticketNumberType}
                    />
                </Box>
            </div>
        </>
    )
}

export default MaintenanceHistory
